import { Button, Pagination } from 'antd';
import React, { FC, useCallback, useMemo, useState } from 'react';
import { TSettingsParams, TSettingsParamsPaginated } from 'shared/types/admins.types';
import { useForm } from 'antd/lib/form/Form';
import Table, { ColumnsType } from 'antd/lib/table';
import { useUpdateSettingsMutation } from 'app/services/edpApiV1/admins';
import { useAppSelector } from 'app/store';
import { Permissions } from 'widgets/sidebar/menu/types';
import UpdatedField from '../updatedField/UpdatedField';
import style from './index.module.scss';

type TSettingsProps = {
  settings?: TSettingsParamsPaginated;
};

const TTLPasswordSettings: FC<TSettingsProps> = ({ settings }) => {
  const [form] = useForm();
  const [page, setPage] = useState<number>(1);
  const [size, setSize] = useState<number>(10);
  const [updating, setUpdating] = useState<number | string>('');
  const [data, setData] = useState<TSettingsParams | null>(null);
  const me = useAppSelector(state => state.entities.viewer.me);

  const handlePagination = (value: number, pageSize: number) => {
    setSize(pageSize);
    setPage(value);
  };

  const pickToUpdate = (setting: TSettingsParams) => {
    setUpdating(setting.id);
    setData(setting);
  };
  const disabled = useMemo(() => {
    const isHavePermissions = me.permissions.find(elem => elem === Permissions['hr.settings.change']);
    return !!isHavePermissions;
  }, [me]);

  const [updateSetting, { isLoading }] = useUpdateSettingsMutation();

  const update = async () => {
    await updateSetting({ id: Number(data?.id), value: data?.value || '' });
    setData(null);
    setUpdating('');
  };

  const columns: ColumnsType<TSettingsParams> = [
    {
      title: '№',
      key: 'key',
      render: (setting: TSettingsParams) => (
        <UpdatedField data={setting} isUpdating={setting.id == updating} field={'id'} setData={setData} />
      ),
    },
    {
      title: 'Наименование',
      key: 'name',

      render: (setting: TSettingsParams) => (
        <UpdatedField data={setting} isUpdating={setting.id == updating} field={'name'} setData={setData} />
      ),
    },
    {
      title: 'Значение',
      key: 'value',

      render: (setting: TSettingsParams) => (
        <UpdatedField data={setting} isUpdating={setting.id == updating} field={'value'} setData={setData} />
      ),
    },
    {
      title: 'Описание',
      key: 'description',

      render: (setting: TSettingsParams) => (
        <UpdatedField data={setting} isUpdating={setting.id == updating} field={'description'} setData={setData} />
      ),
    },
    {
      title: 'Действие',
      key: 'action',
      render: (setting: TSettingsParams) => {
        return (
          <>
            {setting.id == updating ? (
              <Button type="primary" loading={isLoading} disabled={!disabled} onClick={() => update()}>
                Сохранить
              </Button>
            ) : (
              <Button onClick={() => pickToUpdate(setting)} disabled={!disabled}>
                Редактировать
              </Button>
            )}
          </>
        );
      },
    },
  ];

  return (
    <>
      <Table dataSource={settings?.data || []} columns={columns} pagination={false} bordered />
      <div className={style.paginationWrap}>
        <Pagination
          showSizeChanger
          defaultCurrent={size}
          current={page}
          pageSize={size}
          total={settings?.pagination.total}
          onChange={(value: number, pageSize: number) => handlePagination(value, pageSize)}
        />
      </div>
    </>
  );
};

export default TTLPasswordSettings;
